import {getQueryParams} from '@wix/music-shared/dist/src/utils/queryParams/queryParams';
import {BI_ERRORS} from '../biErrorLogger/biErrors';
import {errorLogger} from '../errorLogger/errorLogger';
import {fetchDgs} from './fetchDgs';

export const createPaymentsSnapshot = ({
  instance,
  paymentsId,
  sToken,
  ref,
  albumId,
  trackId = null,
  priceOverride,
  email,
  redirectParams,
}: {
  instance: string;
  paymentsId: string | null;
  sToken: string;
  ref?: string;
  albumId: string;
  trackId?: null | number;
  priceOverride?: number;
  email?: string;
  redirectParams?: object;
}): Promise<{id: string}> => {
  return fetchDgs({
    url: 'https://dgs.wixapps.net/music/cashier/order',
    method: 'POST',
    params: {instance},
    data: {
      collectionId: albumId,
      itemId: trackId || -1,
      ref,
      paymentsId,
      sToken,
      overridePrice: priceOverride,
      email,
      redirectParams,
    },
  })
    .then((resp) => resp.data.order)
    .catch(errorLogger.createLoggingCatcher({bi: BI_ERRORS.getWindow.dgs.createSnapshotId}));
};
